/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareToHomeWorkspaceEndpointRequest
 */
export interface ShareToHomeWorkspaceEndpointRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ShareToHomeWorkspaceEndpointRequest
     */
    paths?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShareToHomeWorkspaceEndpointRequest
     */
    bundles?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ShareToHomeWorkspaceEndpointRequest
     */
    user: number;
    /**
     * 
     * @type {string}
     * @memberof ShareToHomeWorkspaceEndpointRequest
     */
    name: string;
}

export function ShareToHomeWorkspaceEndpointRequestFromJSON(json: any): ShareToHomeWorkspaceEndpointRequest {
    return ShareToHomeWorkspaceEndpointRequestFromJSONTyped(json, false);
}

export function ShareToHomeWorkspaceEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareToHomeWorkspaceEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paths': !exists(json, 'paths') ? undefined : json['paths'],
        'bundles': !exists(json, 'bundles') ? undefined : json['bundles'],
        'user': json['user'],
        'name': json['name'],
    };
}

export function ShareToHomeWorkspaceEndpointRequestToJSON(value?: ShareToHomeWorkspaceEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paths': value.paths,
        'bundles': value.bundles,
        'user': value.user,
        'name': value.name,
    };
}


